import React from "react";
import css from "../images/icons/css3-wordmark.svg";
import html from "../images/icons/html-5.svg";
import bootstrap from "../images/icons/bootstrap-wordmark.svg";
import tailwind from "../images/icons/tailwindcss.svg";
import typescript from "../images/icons/typescript.svg";
import react from "../images/icons/file-type-reactjs.svg";
import next from "../images/icons/nextjs-wordmark.svg";
import node from "../images/icons/nodejs.svg";
import express from "../images/icons/express.svg";
import nestjs from "../images/icons/nestjs.svg";
import mongodb from "../images/icons/mongodb-wordmark.svg";
import mysql from "../images/icons/mysql.svg";
import github from "../images/icons/github.svg";
import git from "../images/icons/git.svg";
import aws from "../images/icons/aws.svg";
import docker from "../images/icons/docker.svg";
import prisma from "../images/icons/prisma.svg";
import cpp from "../images/icons/c-plusplus.svg";
import java from "../images/icons/java-wordmark.svg";
import postgresql from "../images/icons/postgresql-wordmark.svg";
import js from "../images/icons/javascript.svg";
import python from "../images/icons/python.svg";
import "../style/tech.css";
import gif from "../images/web.gif"

const Tech = () => {
  return (
    <>
      <div className="skill-container">
        <div
          className="skillhead"
          data-aos="fade-down-left"
          data-aos-duration="800"
        >
          <div className="waviy">
            <span style={{ "--i": 1 }}>T</span>
            <span style={{ "--i": 2 }}>e</span>
            <span style={{ "--i": 3 }}>c</span>
            <span style={{ "--i": 4 }}>h</span>
            <span style={{ "--i": 5 }} className="delay"></span>
            <span style={{ "--i": 6 }}>S</span>
            <span style={{ "--i": 7 }}>t</span>
            <span style={{ "--i": 8 }}>a</span>
            <span style={{ "--i": 9 }}>c</span>
            <span style={{ "--i": 10 }}>k</span>
          </div>
        </div>
        <div className="skill-s">
          <div className="skill_grid">
            <div className="skill-main b3">
              <div className="shape s3"></div>
              <div
                className="f-skill"
                data-aos="flip-up"
                data-aos-duration="800"
              >
                <div className="skill-name">
                  <h3>Frontend Technologies</h3>
                </div>
                <div className="image">
                  <div className="img-container" data-skill-percentage="100%">
                    <img src={html} alt="HTML5" />
                  </div>
                  <div className="img-container" data-skill-percentage="90%">
                    <img src={css} alt="CSS3" />
                  </div>
                  <div className="img-container" data-skill-percentage="90%">
                    <img src={js} alt="JavaScript" />
                  </div>
                  <div className="img-container" data-skill-percentage="80%">
                    <img src={typescript} alt="TypeScript" />
                  </div>
                  <div className="img-container" data-skill-percentage="90%">
                    <img src={react} alt="React.js" />
                  </div>
                  <div className="img-container" data-skill-percentage="80%">
                    <img src={next} alt="Next.js" />
                  </div>
                  <div className="img-container" data-skill-percentage="70%">
                    <img src={tailwind} alt="Tailwind CSS" />
                  </div>
                  <div className="img-container" data-skill-percentage="60%">
                    <img src={bootstrap} alt="Bootstrap" />
                  </div>
                </div>
              </div>
            </div>
            <div className="skill-main b1">
              <div className="shape s4"></div>

              <div
                className="s-skill"
                data-aos="flip-up"
                data-aos-duration="800"
              >
                <div className="skill-name">
                  <h3>Backend Technologies</h3>
                </div>
                <div className="image backend-image">
                  <div className="img-container" data-skill-percentage="90%">
                    <img src={node} alt="Node.js" />
                  </div>
                  <div className="img-container" data-skill-percentage="90%">
                    <img src={express} alt="Express.js" />
                  </div>
                  <div className="img-container" data-skill-percentage="80%">
                    <img src={nestjs} alt="NestJS" />
                  </div>
                </div>
              </div>
            </div>
            <div className="skill-main b1">
              <div
                className="s-skill"
                data-aos="flip-up"
                data-aos-duration="800"
              >
                <div className="skill-name">
                  <h3>Version Control</h3>
                </div>
                <div className="image">
                  <div className="img-container" data-skill-percentage="90%">
                    <img src={git} alt="Git" />
                  </div>
                  <div className="img-container" data-skill-percentage="80%">
                    <img src={github} alt="GitHub" />
                  </div>
                </div>
              </div>
              <div className="shape s8"></div>
            </div>
          <div className="skill-main b2">
            <div
              className="s1-skill"
              data-aos="flip-up"
              data-aos-duration="800"
            >
              <div className="skill-name">
                <h3>Programming Languages</h3>
              </div>
              <div className="image lang-image">
                <div className="img-container" data-skill-percentage="90%">
                  <img src={js} alt="JavaScript" />
                </div>
                <div className="img-container" data-skill-percentage="70%">
                  <img src={python} alt="Python" />
                </div>
                <div className="img-container" data-skill-percentage="70%">
                  <img src={cpp} alt="C++" />
                </div>
                <div className="img-container" data-skill-percentage="60%">
                  <img src={java} alt="Java" />
                </div>
              </div>
            </div>
            <div className="shape s7"></div>
          </div>
          <div className="skill-main b1">
            <div className="s-skill" data-aos="flip-up" data-aos-duration="800">
              <div className="skill-name">
                <h3>Cloud & DevOps</h3>
              </div>
              <div className="image">
                <div className="img-container" data-skill-percentage="70%">
                  <img src={aws} alt="AWS" />
                </div>
                <div className="img-container" data-skill-percentage="70%">
                  <img src={docker} alt="Docker" />
                </div>
              </div>
            </div>
            <div className="shape s6"></div>
          </div>

          <div className="skill-main b2">
            <div
              className="s1-skill"
              data-aos="flip-up"
              data-aos-duration="800"
            >
              <div className="skill-name">
                <h3>Database & ORM</h3>
              </div>
              <div className="image db-image">
                <div className="img-container" data-skill-percentage="90%">
                  <img src={mysql} alt="MySQL" />
                </div>
                <div className="img-container" data-skill-percentage="80%">
                  <img src={postgresql} alt="PostgreSQL" />
                </div>
                <div className="img-container" data-skill-percentage="80%">
                  <img src={mongodb} alt="MongoDB" />
                </div>
                <div className="img-container" data-skill-percentage="70%">
                  <img src={prisma} alt="Prisma" />
                </div>
              </div>
            </div>
            <div className="shape s5"></div>
          </div>
          <div className="skill-main gif">
            <img src={gif} alt="" />
          </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Tech;
